// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"904":"38454177","908":"45e36bff"}[chunkId] + ".chunk.css";
};